/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_ContactInputs */

const en_directory_footer_link_contact = /** @type {(inputs: Directory_Footer_Link_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const zh_directory_footer_link_contact = /** @type {(inputs: Directory_Footer_Link_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系我们`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Directory_Footer_Link_ContactInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_contact = /** @type {((inputs?: Directory_Footer_Link_ContactInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_ContactInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_contact(inputs)
	return zh_directory_footer_link_contact(inputs)
});
export { directory_footer_link_contact as "directory.footer.link_contact" }